export const FONT = "Calibri";
export const BODY_SIZE = 22;  // 11pt
